import "./Order.module.css";
import Header from "@/reusable_sections/Header";
import VelgDinAiAutomatiseringPakke from "./sections/VelgDinAiAutomatiseringPakke";
import FillOutOrderForm from "./sections/FillOutOrderForm";
import Footer from "@/reusable_sections/Footer";
export default function OrderPage() {
  return <div>
      <Header />
      <VelgDinAiAutomatiseringPakke />
      <FillOutOrderForm />
      <Footer />
    </div>;
}